import React, {PropTypes} from 'react';
import classNames from 'classnames';

const IconStat = ({name, icon, value, showIcon = true}) => {
  const iconStatCssClass = classNames({
    'icon-stat': true,
    [`icon-stat--${icon}`]: icon,
  });
  const iconCssClass = `icon-stat__icon qa-icon qa-icon--${icon}`;
  const valueCssClass = `icon-stat__value icon-stat__value--${icon}`;
  return (
    <div className={iconStatCssClass}>
      {showIcon && <div className={iconCssClass} title={name} />}
      <div className={valueCssClass}>
        <span className="hidden">{name}:</span>
        {value}
      </div>
    </div>
  );
};

IconStat.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  showIcon: PropTypes.bool,
};

export default IconStat;
